import "./modalVideo.css";
import iconoCompartir from "../../assets/imgs/detalle_blog/share-white.svg";
import iconoX from "../../assets/imgs/detalle_blog/logo-x.svg";
import iconoFacebook from "../../assets/imgs/detalle_blog/Asset_Facebook-normal.svg";
import iconoLinkedIn from "../../assets/imgs/detalle_blog/LinkedIn.svg";
import iconoMail from "../../assets/imgs/detalle_blog/Asset_Mail-Normalblanco.svg";
import iconoCopiar from "../../assets/imgs/detalle_blog/Link.svg";


const handleX = () => {
  window.open(
    `https://twitter.com/intent/tweet?url=${encodeURIComponent(
      "https://www.ricardosalinas.com/es/Ideas-en-Corto?idea=" + id_idea
    )}&text=${encodeURIComponent("Idea en corto")}`,
    "_blank"
  );
};

const handleFacebook = () => {
  window.open(
    `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent("https://www.ricardosalinas.com/es/Ideas-en-Corto?idea=" + id_idea)}`,
    "_blank"
  );
};

const handleLinkedIn = (e) => {
  window.open(
    `https://www.linkedin.com/shareArticle?url=${encodeURIComponent(
      "https://www.ricardosalinas.com/es/Ideas-en-Corto?idea=" + id_idea
    )}&title=${encodeURIComponent("Idea en corto")}`,
    "_blank"
  );
};

const handleMail = () => {
  window.location.href = `mailto:?subject=${encodeURIComponent(
    "Idea en corto"
  )}&body=${encodeURIComponent("https://www.ricardosalinas.com/es/Ideas-en-Corto?idea=" + id_idea)}`;
};

const handleCopiarURL = () => {
  navigator.clipboard.writeText("https://www.ricardosalinas.com/es/Ideas-en-Corto?idea=" + id_idea).then(() => {
    alert('¡Enlace copiado al portapapeles!');
  }).catch((error) => {
    console.error('Error al copiar al portapapeles:', error);
  });
};


const ModalVideo = ({ isOpen, closeModal, urlVideo }) => {
  if (!isOpen) return null;
  return (
    <div className="modal">
      <div className="modalContent">
        {/* <div
          className="div_otro"
          dangerouslySetInnerHTML={{ __html: urlVideo }}
        /> */}
        <div className="div_otro">
          <iframe
            // width="840"
            // height="630"
            className="iframeVideo"
            src={urlVideo}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
        <button
          className="botonPop"
          onClick={() => {
            closeModal();
          }}
        >
          <span aria-hidden="true">×</span>
        </button>
        <div className="barra_texto_Desk_div">
          <div className="barra_texto_Desk">
            <button>
              <div className="container-imagen">
                <img src={iconoCompartir} alt="icono compartir" />
              </div>
              <ul className="socials" onClick={(e) => e.stopPropagation()}>
                <li>
                  <img src={iconoX} alt="icono x" onClick={handleX} />
                </li>
                <li>
                  <img
                    src={iconoFacebook}
                    alt="icono facebook"
                    onClick={handleFacebook}
                  />
                </li>
                <li>
                  <img
                    src={iconoLinkedIn}
                    alt="icono linkedIn"
                    onClick={handleLinkedIn}
                  />
                </li>
                <li>
                  <img src={iconoMail} alt="icono mail" onClick={handleMail} />
                </li>
                <li>
                  <img
                    src={iconoCopiar}
                    alt="icono copiar url"
                    onClick={handleCopiarURL}
                  />
                </li>
              </ul>
            </button>
          </div>
        </div>
      </div>
      <div className="background_gri"></div>
    </div>
  );
};
export default ModalVideo;